(function () {
  'use strict';

  class CamadaValorHomeCtrl {
    constructor(Authenticator) {
      this.auth = Authenticator;
      this.init();
    }

    init() {
      this.auth.getUser().then(user => {
        /* eslint-disable */
        const elementContainer = document.querySelector('#camada-valor-home-element'),
          camadaValorHomeElement = document.createElement('pwc-camada-valor-home');
        /* eslint-enable */

        if (camadaValorHomeElement) {
          camadaValorHomeElement.userUoId = user.plain().uo.id;
          camadaValorHomeElement.hasUpdatePermission = user.plain().permissoes.includes('CAMADA_VALOR_EDITAR');
          elementContainer.appendChild(camadaValorHomeElement);
        }
      });
    }
  }

  angular
    .module('camadaValor')
    .controller('CamadaValorHomeCtrl', CamadaValorHomeCtrl);
}());
